const $ = jQuery.noConflict();

'use strict';
const LoadMoreTabs = {
	$domLoadBtn: $('.js-load-more-specials'),
	$specialsButtonLoader: $('.js-specials-button-loader'),
	closePillIcon: document.location.protocol + '//' + window.location.host + '/wp-content/themes/fws-eastern-tabletop/src/assets/svg/ico-close.svg',
	closePillIconSvg: '',
	taxonomyType: '',
	perPage: 8,
	loadedSubcategoryProducts: [],
	activeProductsHtml: [],
	defaultResults: [],
	ajaxExecuting: [],
	expectsOutput: [],
	page: [],
	nextPage: [],
	listToShow: [],
	taxonomies: [],
	productsLeft: [],
	linkParam: window.fwsLinkParam,

	init: function() {
		if ($('.js-build-section__tabs-boxes').length > 0) {
			this.storeOriginalHtml();
			this.initPerPage();
			this.initSvgContent();
			this.initDefaultCount();
			this.initPagination();
			this.addLoadMoreListeners();
		}
	},

	/**
	 * Sets up HTML for the SVG icon for our pills
	 */
	initSvgContent: function() {
		this.closePillIconSvg = `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" fill="currentColor">
			<path d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"></path>
			</svg>
		`;
	},

	/**
	 * Initializes default count values for each taxonomy tab
	 */
	initDefaultCount: function() {
		const _this = this;
		$('.js-results-count').each(function(index, element) {
			const taxonomy = $(element).data('taxonomy');
			_this.defaultResults[taxonomy] = parseInt($(element).data('count'));
		});
	},


	/**
	 * Stores the original HTML displayed at the initial page state
	 */
	storeOriginalHtml: function(taxonomy = null) {
		const _this = this;
		if (taxonomy === null) {
			$('.build-section__tabs-boxes-products').each(function(index, element) {
				const taxonomy = $(element).data('taxonomy');
				_this.activeProductsHtml[taxonomy] = $(element).clone();
			});
		} else {
			const container = $('.build-section__tabs-boxes-products[data-taxonomy="' + taxonomy + '"]');
			if (container.length) {
				_this.activeProductsHtml[taxonomy] = $(container).clone();
			}
		}
	},

	/**
	 * Add listeners and handlers to the load more button
	 */
	addLoadMoreListeners: function() {
		const _this = this;
		$('.js-load-more-tabs').on('click', function() {
			const parentContainer = $(this).closest('.js-build-section__tabs-boxes');
			const hasMorePages = $(this).data('has-more-pages');
			if (parentContainer.length > 0) {
				const hiddenProducts = parentContainer.find('.hidden-element')
					.not('.js-filter-tabs-container')
					.not('.js-type-number-container')
					.not('.js-cancel-subcategory-filter');
				if (hiddenProducts.length > 0) {
					hiddenProducts.removeClass('hidden-element');
				}

				const taxonomy = parentContainer.data('taxonomy');
				if (_this.ajaxExecuting.includes(taxonomy)) {
					_this.toggleButtonLoader(taxonomy, true);
					_this.expectsOutput.push(taxonomy);
				} else {
					if (!hasMorePages) {
						$(this).remove();
					} else {
						_this.loadMoreProductsForTaxonomy(taxonomy);
					}
				}
			}
			_this.storeOriginalHtml();
		});

		$('.js-type-checkbox').on('change', function() {
			_this.showLoader(true);
			const taxonomy = $(this).data('taxonomy');
			const parentWrapper = $('.js-filters-wrapper[data-taxonomy="' + taxonomy + '"]');
			const checkedCheckboxes = parentWrapper.find('.js-type-checkbox:checked');
			const subcategories = [];

			if (checkedCheckboxes.length === 0) {
				_this.resetCategoryFilter(taxonomy);
				_this.hideClearBtn(true, taxonomy);
				_this.updateResultsCount(taxonomy, _this.defaultResults[taxonomy]);
			} else {
				_this.hideClearBtn(false, taxonomy);
				checkedCheckboxes.each(function() {
					const taxonomyValue = $(this).val();
					if (taxonomyValue) {
						subcategories.push(taxonomyValue);
					}
				});

				if (taxonomy && subcategories.length > 0) {
					_this.loadSubcategoryProducts(taxonomy, subcategories);
					const loadMoreButton = $('.js-load-more-tabs[data-taxonomy="' + taxonomy + '"]');
					loadMoreButton.addClass('hidden-element');
				}
			}
		});

		$('.js-cancel-subcategory-filter').on('click', function() {
			const taxonomy = $(this).data('taxonomy');
			_this.resetCategoryFilter(taxonomy);
			_this.hideClearBtn(true, taxonomy);
		});
	},

	/**
	 * When AJAX is successful, update the pills
	 * @param taxonomy
	 */
	updateFilterPills: function(taxonomy) {
		const _this = this;
		const parentWrapper = $('.js-filters-wrapper[data-taxonomy="' + taxonomy + '"]');
		const checkedCheckboxes = parentWrapper.find('.js-type-checkbox:checked');
		const mainTabsContainer = parentWrapper.closest('.js-build-section__tabs-boxes').find('.js-filter-tabs-container');

		mainTabsContainer.addClass('hidden-element');
		mainTabsContainer.html('');
		checkedCheckboxes.each(function() {
			const taxonomySlug = $(this).val();
			const taxonomyName = $(this).attr('name');

			if (taxonomySlug) {
				const pillHtml = `
                <div class="product-listing__upper-filter js-single-pill-container" data-taxonomy="${taxonomySlug}">
                    <span class="product-listing__upper-filter-title">${taxonomyName}</span>
                    <span class="js-pill-close-icon product-listing__upper-filter-ico svg-icon">
                        ${_this.closePillIconSvg}
                    </span>
                </div>
            `;
				mainTabsContainer.prepend(pillHtml);
			}
		});

		if (checkedCheckboxes.length > 0) {
			mainTabsContainer.removeClass('hidden-element');
			$('.js-type-number-container[data-taxonomy="' + taxonomy + '"]').removeClass('hidden-element');
			$('.js-type-number[data-taxonomy="' + taxonomy + '"]').text(checkedCheckboxes.length);
		} else {
			$('.js-type-number-container[data-taxonomy="' + taxonomy + '"]').addClass('hidden-element');
			_this.updateResultsCount(taxonomy, _this.defaultResults[taxonomy]);
		}

		$('.js-pill-close-icon').load(this.closePillIcon);
		_this.addClosePillListener(taxonomy);
	},


	/**
	 * Adds handler to pill close
	 * @param taxonomy
	 */
	addClosePillListener: function(taxonomy) {
		const _this = this;
		const wrapper = $('.js-filters-wrapper[data-taxonomy="' + taxonomy + '"]');
		if (wrapper) {
			const pillsClose = wrapper.find('.js-pill-close-icon');
			if (pillsClose.length) {
				pillsClose.off('click').on('click', function() {
					const subType = $(this).parent().data('taxonomy');
					$(this).closest('.js-single-pill-container').remove();
					wrapper.find(`input[value="${subType}"]`).prop('checked', false).change();
					const checkedCheckboxes = wrapper.find('.js-type-checkbox:checked');
					if (checkedCheckboxes.length > 0) {
						$('.js-type-number-container[data-taxonomy="' + taxonomy + '"]').removeClass('hidden-element');
						$('.js-type-number[data-taxonomy="' + taxonomy + '"]').text(checkedCheckboxes.length);
					} else {
						$('.js-type-number-container[data-taxonomy="' + taxonomy + '"]').addClass('hidden-element');
						$('.js-load-more-subcategory-tabs').remove();
						_this.updateResultsCount(taxonomy, _this.defaultResults[taxonomy]);
					}
				});
			}
		}
	},

	/**
	 * Resets category filter for specific taxonomy
	 * @param taxonomy
	 */
	resetCategoryFilter: function(taxonomy) {
		if (this.activeProductsHtml[taxonomy]) {
			const container = $('.build-section__tabs-boxes-products[data-taxonomy="' + taxonomy + '"]');
			if (container.length) {
				container.replaceWith(this.activeProductsHtml[taxonomy].clone());
				this.updateResultsCount(taxonomy, this.defaultResults[taxonomy] ?? 0);
			}
			const loadMoreButton = $('.js-load-more-tabs[data-taxonomy="' + taxonomy + '"]');
			if (loadMoreButton.length) {
				loadMoreButton.removeClass('hidden-element');
			}

			const parentWrapper = $('.js-filters-wrapper[data-taxonomy="' + taxonomy + '"]');
			const checkedCheckboxes = parentWrapper.find('.js-type-checkbox:checked');
			checkedCheckboxes.each(function() {
				$(this).prop('checked', false);
			});

			this.showLoader(false);
			this.updateFilterPills(taxonomy);
		}
	},

	/**
	 * Loads new products for a specific taxonomy and page
	 */
	loadSubcategoryProducts: function(taxonomy, subcategories) {
		const _this = this;
		$.ajax({
			method: 'POST',
			url: window.fwsLocalized.ajaxUrl,
			data: {
				action: 'load-subcategory-products',
				subcategories: subcategories,
				taxonomy: taxonomy,
			},
			beforeSend: function() {
				if (_this.loadedSubcategoryProducts[taxonomy]) {
					_this.loadedSubcategoryProducts[taxonomy] = [];
				}
			},
			success: function(response) {
				_this.showLoader(false);
				if (response.success) {
					LoadMoreTabs.termID = response.data.termID;
					const container = $('.build-section__tabs-boxes-products[data-taxonomy="' + taxonomy + '"]');
					if (container.length) {
						container.html('');
						if (response.data.products.length > _this.perPage) {
							// prepare products to show and products to keep in buffer (for load more)
							const productsToShow = response.data.products.slice(0, _this.perPage);
							const productsToBuffer = response.data.products.slice(_this.perPage);
							_this.renderProducts(productsToShow, taxonomy);
							_this.updateResultsCount(taxonomy, response.data.products.length);
							_this.loadedSubcategoryProducts[taxonomy] = productsToBuffer;
							_this.appendSubcategoryLoadMoreButton(taxonomy);
						} else {
							_this.renderProducts(response.data.products, taxonomy);
							_this.updateResultsCount(taxonomy, response.data.products.length);
						}

						// update pills
						_this.updateFilterPills(taxonomy);
					}
				}
			},
		});
	},


	appendSubcategoryLoadMoreButton: function(taxonomy) {
		const _this = this;
		const bufferCount = this.loadedSubcategoryProducts[taxonomy].length ?? 0;
		// check if there is more products to load
		if (bufferCount > 0) {
			const loadMore = bufferCount > this.perPage ? this.perPage : bufferCount;
			const subcategoryLoadMore = $('.js-load-more-subcategory-tabs');
			subcategoryLoadMore.remove();
			// add button to the HTML if there is more products to load
			const buttonHtml = `
				<a
					class="build-section__tabs-boxes-btn js-load-more-subcategory-tabs"
					href="javascript:;"
					data-taxonomy="${taxonomy}"
				>
					<span class="build-section__tabs-boxes-btn-text">Load</span>
					<span class="build-section__tabs-boxes-btn-dot"></span>
					<span class="build-section__tabs-boxes-btn-more js-tabs-button-counter">${loadMore} More</span>
				</a>
			`;

			$('.js-build-section__tabs-boxes[data-taxonomy="' + taxonomy + '"]').append(buttonHtml);

			// append event listeners to the button - they append new content to the page from the buffer
			$('.js-load-more-subcategory-tabs').on('click', function() {
				const taxonomy = $(this).data('taxonomy');
				const productsToShow = _this.loadedSubcategoryProducts[taxonomy].slice(0, _this.perPage);
				_this.loadedSubcategoryProducts[taxonomy] = _this.loadedSubcategoryProducts[taxonomy].slice(_this.perPage);
				_this.renderProducts(productsToShow, taxonomy);

				const bufferCount = _this.loadedSubcategoryProducts[taxonomy].length ?? 0;
				if (bufferCount > 0) {
					const loadMore = bufferCount > _this.perPage ? _this.perPage : bufferCount;
					$(this).find('.js-tabs-button-counter').text(loadMore + ' More');
				} else {
					$(this).remove();
				}
			});
		}
	},

	/**
	 * Updates number of results for specific taxonomy element
	 * @param taxonomy
	 * @param count
	 */
	updateResultsCount: function(taxonomy, count) {
		const resultsCounter = $('.js-results-count[data-taxonomy="' + taxonomy + '"]');
		if (resultsCounter.length) {
			const msg = count === 1 ? ' Result' : ' Results';
			resultsCounter.text(count + msg);
		}
	},

	/**
	 * Loads new products for a specific taxonomy and page
	 */
	loadMoreProductsForTaxonomy: function(taxonomy) {
		const _this = this;
		if (typeof _this.productsLeft[taxonomy] === 'undefined' || _this.productsLeft[taxonomy] > 0) {
			$.ajax({
				method: 'POST',
				url: window.fwsLocalized.ajaxUrl,
				data: {
					action: 'load-more-tabs',
					page: _this.nextPage[taxonomy] ?? 1,
					perPage: _this.perPage,
					term: taxonomy,
					taxonomyType: _this.taxonomyType,
				},
				beforeSend: function() {
					_this.ajaxExecuting.push(taxonomy);
				},
				success: function(response) {
					LoadMoreTabs.termID = response.data.termID;
					_this.listToShow[taxonomy] = response.success ? response.data : [];
					_this.bindEvents(taxonomy);
					_this.updateButtonText(response.data.products.length, taxonomy);
					_this.productsLeft[taxonomy] = response.data.products_left;
				},
				error: function() {
					_this.listToShow[taxonomy] = [];
				},
				complete: function() {
					_this.ajaxExecuting = _this.ajaxExecuting.filter(item => item !== taxonomy);
					_this.renderOutput(taxonomy);
					_this.toggleButtonLoader(taxonomy, false);
				},
			});
		} else {
			_this.updateButtonText(0, taxonomy);
		}
	},

	/**
	 * show/hide button loader and disable/enable the button
	 * @param taxonomy
	 * @param show
	 */
	toggleButtonLoader: function(taxonomy, show) {
		const container = $('.js-build-section__tabs-boxes[data-taxonomy="' + taxonomy + '"]');
		if (container.length) {
			const button = container.find('.js-load-more-tabs').first();
			if (button.length) {
				if (show) {
					button.addClass('is-active');
					button.prop('disabled', true);
				} else {
					button.removeClass('is-active');
					button.prop('disabled', false);
				}
			}
		}
	},

	/**
	 * Set default next page for each taxonomy. We preload the first 2, so 3 is the next one to load
	 */
	initPagination: function() {
		const _this = this;
		const taxonomyButtons = $('.js-build-section__tabs-btn');
		_this.taxonomyType = $('.js-build-section__tabs').data('taxonomy-type');
		taxonomyButtons.each(function(index, element) {
			const taxonomy = $(element).data('taxonomy');
			if (taxonomy) {
				_this.nextPage[taxonomy] = 3;
			}
		});
	},

	/**
	 * Set number of results per page
	 */
	initPerPage: function() {
		const perPage = $('.js-load-more-tabs').data('per-page');
		if (perPage) {
			this.perPage = perPage;
		}
	},

	/**
	 * Binds events to load more button after ajax is complete
	 * @param taxonomy
	 */
	bindEvents: function(taxonomy) {
		const _this = this;
		const container = $('.js-build-section__tabs-boxes[data-taxonomy="' + taxonomy + '"]');
		if (container.length) {
			container.find('.js-load-more-tabs').first().off('click').on('click', function() {
				if (_this.ajaxExecuting.includes(taxonomy)) {
					_this.toggleButtonLoader(taxonomy, true);
					_this.expectsOutput.push(taxonomy);
				} else {
					_this.renderOutput(taxonomy, true);
				}
			});
		}
	},

	/**
	 * @param taxonomy
	 * @param force
	 */
	renderOutput: function(taxonomy, force) {
		if (this.expectsOutput.includes(taxonomy) || force) {
			if (this.listToShow[taxonomy]?.products?.length > 0) {
				const products = this.listToShow[taxonomy].products;
				this.renderProducts(products, taxonomy);
				this.listToShow[taxonomy] = [];
				this.nextPage[taxonomy]++;
				this.loadMoreProductsForTaxonomy(taxonomy);
				this.storeOriginalHtml(taxonomy);
			}

			this.expectsOutput = this.expectsOutput.filter(item => item !== taxonomy);
		}
	},

	/**
	 * Appends HTML for the fetched products
	 * @param products
	 * @param taxonomy
	 */
	renderProducts: function(products, taxonomy) {
		products.forEach((product) => {
			const url = product.url ?? '';
			const link = LoadMoreTabs.termID ? url + '?category=' + LoadMoreTabs.termID : url;
			const html = `
				<div class="product-more-like__slide-inner ">
					<div class="product-more-like__slide-img-container">
						<img src="${product.image ?? ''}" loading="lazy" alt="${product.title ?? ''}">
					</div>
					<div class="product-more-like__slide-content">
						<p class="product-more-like__slide-title anuphan-18">${product.title ?? ''}</p>
						<span class="product-more-like__slide-dimensions anuphan-16">${product.size ?? ''}</span>
					</div>
					<a class="btn btn--slim btn--border btn--border-fill" href="${link}">View Details</a>
				</div>
			`;

			const container = $('.build-section__tabs-boxes-products[data-taxonomy="' + taxonomy + '"]');
			if (container.length) {
				container.append(html);
			}
		});
	},

	/**
	 * Updates button text with the products left string
	 * @param productsLeft
	 * @param taxonomy
	 */
	updateButtonText: function(productsLeft, taxonomy) {
		const container = $('.js-build-section__tabs-boxes[data-taxonomy="' + taxonomy + '"]');
		if (container.length) {
			if (productsLeft === 0) {
				container.find('.js-load-more-tabs').first().remove();
			} else {
				container.find('.js-tabs-button-counter').first().text(productsLeft + ' more');
			}
		}
	},

	showLoader: (show)=> {
		$('.js-dropdown-el').toggleClass('is-active', show);
		$('.js-main-loader').toggleClass('is-active', show);
	},

	hideClearBtn: (show, taxonomy)=>{
		$(`.js-cancel-subcategory-filter[data-taxonomy="${taxonomy}"]`).toggleClass('hidden-element', show);
	},

	hideFilterNumber: (show)=>{
		$('.js-type-number-container').toggleClass('hidden-element', show);
	}

};

export default LoadMoreTabs;
